// Apps Registry - Auto-generated for 750.developmentsnapshot.com
// This file is generated at deploy time for isolated single-app deployments

import * as JobsMonitor from './jobs-monitor';
import * as Project750k from './project750k';

// App registry - only includes apps for this deployment
export const appRegistry = {
  'jobs-monitor': {
    name: 'Jobs Monitor',
    description: 'Monitor DynamoDB Jobs System operations',
    category: 'Monitoring',
    icon: 'MONITOR',
    color: '#6f42c1',
    exports: JobsMonitor
  },
  'project750k': {
    name: 'PROJECT 750K - UCC Data Viewer',
    description: 'Colorado UCC Farm Product Financing Statements Database',
    category: 'Business',
    icon: 'APP',
    color: '#0066cc',
    exports: Project750k
  }
};

// Helper to get all available apps as an array
export const getAvailableApps = () => {
  return Object.keys(appRegistry).map(id => ({
    id,
    ...appRegistry[id]
  }));
};

// Helper to get app exports by ID
export const getAppExports = (appId) => {
  return appRegistry[appId]?.exports || null;
};

// Helper to get the default app from deployment config
export const getDefaultApp = () => {
  return null;  // Determined by deployment config at runtime
};
